import "./stars.css";

export const Stars = ({ value }: { value: number }) => {
  const n = Math.max(0, Math.min(5, Math.round(value)));

  return (
    <div className="oc-stars" aria-label={`${n} of 5`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span
          key={i}
          className={`oc-star ${i < n ? "oc-star--on" : "oc-star--off"}`}
        />
      ))}
    </div>
  );
};
